import { render, staticRenderFns } from "./TriggerTextFieldWithEdit.vue?vue&type=template&id=1872f254&"
import script from "./TriggerTextFieldWithEdit.vue?vue&type=script&lang=js&"
export * from "./TriggerTextFieldWithEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports